import { UserMenu } from '@olytic/foundation';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMyProfile } from './ProfileProvider';
import { SETTINGS_ROUTE } from './routes';
import { YourPhotoDialog } from './YourPhotoDialog';

/** The top bar's account menu: name and photo, Your settings, Your photo, Sign out. */
export function YourUserMenu(): JSX.Element {
  const navigate = useNavigate();
  const { displayName, email, avatarUrl, signOut } = useMyProfile();
  const [photoOpen, setPhotoOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <UserMenu
        ref={triggerRef}
        actions={[
          { key: 'settings', label: 'Your settings', onSelect: () => navigate(SETTINGS_ROUTE) },
          { key: 'photo', label: 'Your photo', onSelect: () => setPhotoOpen(true) },
        ]}
        {...(avatarUrl === undefined ? {} : { avatarUrl })}
        email={email}
        name={displayName}
        onSignOut={() => void signOut()}
      />
      <YourPhotoDialog open={photoOpen} onClose={() => setPhotoOpen(false)} returnFocusRef={triggerRef} />
    </>
  );
}
